import React, { FunctionComponent } from 'react';
import { ArticleModel } from '../../../services/content/article/models/ArticleModel';
import { ArticleBlockModel } from '../../../services/content/articleBody/models/ArticleBlockModel';
import { ImageBlockModel } from '../../../services/content/articleBody/models/ImageBlockModel';
import { EditorBlockModel } from '../../../services/content/articleBody/models/EditorBlockModel';
import { RelatedModel } from '../../../services/content/related/models/RelatedModel';
import { Templates } from './enums/Templates';
import { TemplateDefault } from './TemplateComponents/TemplateDefault';
import { Template1 } from './TemplateComponents/Template1';
import { Template2 } from './TemplateComponents/Template2';

type Props = {
    template: string;
    article: ArticleModel;
    body: (ArticleBlockModel | ImageBlockModel | EditorBlockModel | null)[];
    related: RelatedModel[];
};

export const ArticleTemplates: FunctionComponent<Props> = ({ template, article, body, related }) => {
    switch (template) {
        case Templates.TEMPLATE_1: {
            return <Template1 article={article} body={body} related={related} />;
        }
        case Templates.TEMPLATE_2: {
            return <Template2 article={article} body={body} related={related} />;
        }
        default: {
            return <TemplateDefault article={article} body={body} related={related} />;
        }
    }
};
